/**
 * 판매 급증으로 인한 취소가능성 알림 레이어
 */
export default class SurgeSaleDealLayer {
  constructor() {
    this.welContainer = $('#_layerContainer');
    this.sWrapper = '_surgeSaleDealLayer';
    this.sStorageKey = '';
    this.isCheckCart = false;
    this.isCheckBuy = false;
    this.isCheckGift = false;

    this.render();
  }

  isCheckedCart = () => this.isCheckCart;

  isCheckedBuy = () => this.isCheckBuy;

  isCheckedGift = () => this.isCheckGift;

  setEvent = () => {
    this.welContainer.on(
      'click',
      `#${this.sWrapper} .btn_confirm`,
      this.onConfirm
    );
    this.welContainer.on('click', `#${this.sWrapper} .btn_close`, this.onClose);
  };

  clearEvent = () => {
    this.welContainer.off('click', `#${this.sWrapper} .btn_confirm`);
  };

  onConfirm = e => {
    e.preventDefault();
    TMON.oApp.oViews.closeLayer();

    switch (this.sStorageKey) {
      case 'validateAddToCart':
        TMON.oApp.setStorage('validateAddToCart');
        break;
      case 'validateBuyNow':
        TMON.oApp.setStorage('validateBuyNow', {
          type: 'default',
        });
        break;
      case 'validateBuyGift':
        TMON.oApp.setStorage('validateBuyGift', true);
        break;
      default:
        break;
    }
  };

  onClose = e => {
    e.preventDefault();
    TMON.oApp.oViews.closeLayer();
  };

  open = sStorageKey => {
    this.clearEvent();
    this.setEvent();
    this.sStorageKey = sStorageKey;

    if (TMON.oApp.sPlatform === 'PW') {
      TMON.oApp.oUtil.handleOpenLayer({
        welTargetLayer: $(`#${this.sWrapper}`),
        bSetHash: false,
        bUseHistorybackOnClose: true,
        bShowDimmed: false,
      });
    } else {
      TMON.oApp.oUtil.handleOpenLayer({
        welTargetLayer: $(`#${this.sWrapper}`),
      });
    }
  };

  render = () => {
    const sHTML = `
            <section id="${this.sWrapper}" class="popup popup_layer popup_phishing">
                <header class="popup_header">
                    <h3 class="popup_header_title">구매 전 꼭 확인해 주세요.</h3>
                    <button type="button" class="popup_header_close btn_close" aria-label="팝업닫기" data-role="close">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                          <path fill="#30343B" fill-rule="evenodd" d="M0 0h.87v.87H0V0zm.87.87h.87v.87H.87V.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87H20V20h-.87v-.87zM20 0v.87h-.87V0H20zm-.87.87v.87h-.87V.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-.87.87v.87h-.87v-.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-1.739 1.739v.87h-.87v-.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-.87.87v.87h-.87v-.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-.87.87v.869H1.74v-.87h.87zm-.869.869v.87H.87v-.87h.87zm-.87.87V20H0v-.87h.87z"></path>
                      </svg>
                    </button>
                </header>
                <div class="popup_contents">
                    <article class="popup_inner">
                        <dl class="popup_definition_area">
                            <dt>
                                <strong class="blind">배송비</strong>
                            </dt>
                            <dd>
                                <p class="popup_definition_desc">
                                    최근 2주내에 판매량이 급증한 딜입니다. 판매자 사정에 따라 부득이하게 배송이 지연되거나 구매가 취소될 수 있습니다.
                                </p>
                            </dd>
                        </dl>
                    </article>
                    <div class="popup_buttons">
                        <button type="button" class="popup_button type01 btn_confirm">
                            확인
                        </button>
                    </div>
                </div>
            </section>
        `;

    this.welContainer.append(sHTML);
  };
}
